function initAccordion() {
  if (window.innerWidth <= 1200) {
    const stepTitles = document.querySelectorAll(".controller-step .step-title");

    stepTitles.forEach((title) => {
      title.removeEventListener("click", toggleAccordion);
      title.addEventListener("click", toggleAccordion);
    });
  }
}

function toggleAccordion() {
  const stepTitles = document.querySelectorAll(".controller-step .step-title");

  stepTitles.forEach((t) => {
    if (t !== this) {
      t.classList.remove("open");
      t.style.marginBottom = "0px";
      const otherContent = t.parentElement.querySelectorAll(".step-description");
      otherContent.forEach((desc) => {
        desc.style.maxHeight = null;
        desc.style.marginBottom = "0px";
      });
    }
  });

  const contentContainer = this.parentElement.querySelectorAll(".step-description");
  let isOpen = this.classList.contains("open");

  if (isOpen) {
    this.classList.remove("open");
    this.style.marginBottom = "0px";
    contentContainer.forEach((desc) => {
      desc.style.maxHeight = null;
      desc.style.marginBottom = "0px";
    });
  } else {
    this.classList.add("open");
    this.style.marginBottom = "19px";
    contentContainer.forEach((desc) => {
      desc.style.maxHeight = desc.scrollHeight + "px";
      desc.style.marginBottom = "19px";
    });
  }
}

document.addEventListener("DOMContentLoaded", initAccordion);

window.addEventListener("resize", initAccordion);



document.addEventListener("DOMContentLoaded", function () {
  const mobileWrapper = document.querySelector(".mobile-only-wrapper");
  const scrollbar = document.querySelector(".custom-scrollbar");
  const thumb = scrollbar.querySelector(".custom-scrollbar-thumb");

  if (!mobileWrapper || !scrollbar || !thumb) {
    return;
  }


  mobileWrapper.addEventListener("scroll", function () {

    let scrollLeft = mobileWrapper.scrollLeft;
    let scrollWidth = mobileWrapper.scrollWidth - mobileWrapper.clientWidth;
    let maxThumbMove = scrollbar.clientWidth - thumb.clientWidth;

    if (scrollWidth > 0) {
      let scrollPercent = scrollLeft / scrollWidth;
      let newLeft = scrollPercent * maxThumbMove;
    

      thumb.style.left = `${newLeft}px`;
    }
  });

  if (mobileWrapper) {
    mobileWrapper.addEventListener("wheel", function (event) {
      if (event.deltaY !== 0) {
        event.preventDefault();
        mobileWrapper.scrollLeft += event.deltaY;
      }
    });
  }
});
